module.exports = __webpack_public_path__ + "img/message8.3d114dbd.png";